import { render, staticRenderFns } from "./CDNTabs.vue?vue&type=template&id=e101e55a&scoped=true&"
import script from "./CDNTabs.vue?vue&type=script&lang=js&"
export * from "./CDNTabs.vue?vue&type=script&lang=js&"
import style0 from "./CDNTabs.vue?vue&type=style&index=0&id=e101e55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e101e55a",
  null
  
)

export default component.exports